/* flow */
import React, { PureComponent } from 'react'
import {FundValueCell, NumberCell} from './ListCells'
import {capitalize} from './globals'
import Leaf from './Leaf';

type Props = {
  id: string,
  name: string,
  change: ?number,
  valuation: ?number,
  m: ?number,
  y: ?number,
  y3: ?number,
  y5: ?number,
  yMax: ?number,
  color: string,
  bgColor: string,
  width: number,
  onClick: (id: string) => (event: SyntheticEvent<>) => void,
  mode: Mode,
  sfdrLevel: ?number
}

export default class LegendRow extends PureComponent<Props> {
  render () {
    const { id, name, change, valuation, m, y, y3, y5, yMax, color, bgColor, onClick, width, mode, sfdrLevel, lang} = this.props
    return (
      <tr onClick={onClick(id)}>
        <NameCell { ...{name, color, bgColor, sfdrLevel} }/>
        <FundValueCell num={valuation} lang={lang}/>
        <NumberCell num={change} percent/>
        {width >= 768 && <NumberCell num={m} percent/>}
        {width >= 768 && <NumberCell num={y} percent/>}
        {width >= 1200 && <NumberCell num={y3} percent/>}
        {width >= 1200 && capitalize(mode) !=='Pte' && <NumberCell num={y5} percent/>  }
        {width >= 1200 && capitalize(mode) === 'Pte' && <NumberCell num={yMax} percent/>}
      </tr>
    )
  }
}

class NameCell extends PureComponent<{ name: string, color: string, bgColor: string, sfdrLevel: ?number }> {
  renderLeaves() {
    const { sfdrLevel } = this.props;
    const renderLeaves = [];
    for (let i = 0; i < sfdrLevel; i++) {
      renderLeaves.push(<Leaf key={i} />);
    }
    return renderLeaves;
  }
  render () {
    const { name, color, bgColor } = this.props
    return (
      <td style={{ color }}>
        <div className='ac-chart-tooltip__shape' style={{ backgroundColor: bgColor, marginRight: 10 }}></div>
        <span>{name}</span>
        {/*{this.renderLeaves()}*/}
      </td>
    )
  }
}



// WEBPACK FOOTER //
// ./src/LegendRow.js